import { Schema, SchemaSettings } from '@orbit/data'
import { findRemoteIdFromNewRecord, KC } from '@/http/utils'
import moment from 'moment-timezone'

enum ModelTypes {
  PatientNotes = 'patient-note',
}

enum ModelTypeNames {
  PatientNotes = 'patientNote',
}

export interface PatientNoteAttributes {
  patientId: string
  patientFirstName: string
  patientLastName: string
  userId: string
  userFirstName: string
  userLastName: string
  content: string
  createdTimestamp: number
}

export interface PatientNoteSchema {
  id: string
  attributes: PatientNoteAttributes
}

const schemaDefinition: SchemaSettings = {
  models: {
    [ModelTypeNames.PatientNotes]: {
      keys: {
        remoteId: {},
      },
      attributes: {
        patientId: { type: 'string' },
        patientFirstName: { type: 'string' },
        patientLastName: { type: 'string' },
        pid: { type: 'string' },
        userId: { type: 'string' },
        userFirstName: { type: 'string' },
        userLastName: { type: 'string' },
        content: { type: 'string' },
        createdTimestamp: { type: 'string' },
      },
    },
  },
}

export async function getPatientNotesQuery() {
  const schema = new Schema(schemaDefinition)
  const remote = await KC.getJsonApiRemoteResource(schema)
  return remote
    .query(q => {
      console.log('Before calling find record for patient notes')
      return q.findRecords(ModelTypes.PatientNotes)
    })
    .catch(e => {
      console.log('fetch failed for patient notes')
      console.log(e)
    })
}

export async function getPatientNotesByPatientIdQuery(patientId: string) {
  const schema = new Schema(schemaDefinition)
  const remote = await KC.getJsonApiRemoteResource(schema)
  return remote
    .query(q => {
      console.log('Before calling find record')
      return q.findRecords(ModelTypes.PatientNotes).filter({ attribute: 'pid', value: patientId })
    })
    .catch(() => console.log('fetch failed'))
}

export async function addPatientNoteQuery(note: {
  patientId: string
  userId: string
  userFirstName: string
  userLastName: string
  content: string
}) {
  const schema = new Schema(schemaDefinition)
  const remote = await KC.getJsonApiRemoteResourceForNewRecord(schema)
  const result = await remote.push(q => {
    console.log('Before calling push record')
    return q.addRecord({
      id: '',
      type: ModelTypeNames.PatientNotes,
      attributes: {
        patientId: note.patientId,
        userId: note.userId,
        userFirstName: note.userFirstName,
        userLastName: note.userLastName,
        content: note.content,
        createdTimestamp: moment().unix() * 1000,
      },
    })
  })
  return findRemoteIdFromNewRecord(result)
}

export async function updatePatientNoteQuery(note) {
  const schema = new Schema(schemaDefinition)
  const remote = await KC.getJsonApiRemoteResource(schema)
  return remote.push(q => {
    console.log('Before calling update record')
    return q.updateRecord({
      id: note.id,
      type: ModelTypeNames.PatientNotes,
      attributes: {
        content: note.content,
      },
    })
  })
}

export async function deletePatientNoteQuery(note) {
  const schema = new Schema(schemaDefinition)
  const remote = await KC.getJsonApiRemoteResource(schema)
  console.log('Before calling remove record for patient note', note)
  return remote.push(q => {
    return q.removeRecord({
      id: note.id,
      type: ModelTypeNames.PatientNotes,
    })
  })
}
